import { ComputedTeam } from './types/computed/ComputedTeam';

export const getTeamLink = (
  team: ComputedTeam,
  hasLinks: boolean | undefined
): string | null => {
  if (!hasLinks || !team?.route) return null;

  const rawRoute = team.route;

  if (team.mainEntityType === 'channels') {
    const authUrl = process.env.REACT_APP_URL_MEDIIIA_COM!;
    const targetHost = authUrl.replace(/^https?:\/\//, '').split('/')[0];
    
    return rawRoute.replace(/^https?:\/\/[^\/]+/, `https://${targetHost}`);
  }

  return rawRoute;
};import { ComputedTeam } from './types/computed/ComputedTeam';

export const getTeamLink = (
  team: ComputedTeam,
  hasLinks: boolean | undefined
): string | null => {
  if (!hasLinks || !team?.route) return null;

  const rawRoute = team.route;

  if (team.mainEntityType === 'channels') {
    const authUrl = process.env.REACT_APP_URL_MEDIIIA_COM!;
    const targetHost = authUrl.replace(/^https?:\/\//, '').split('/')[0];
    
    return rawRoute.replace(/^https?:\/\/[^\/]+/, `https://${targetHost}`);
  }

  return rawRoute;
};